// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  if (chunkId === "7888") return "css/design_system-04e5911f74499c67.css";
if (chunkId === "5687") return "css/5687-407b17dbc4247f26.css";
  // return url for filenames based on template
  return "css/" + chunkId + "-" + {"193": "be9cbf0b8df1f1f7","1951": "f0491952cbf0d82a","2108": "25e43d52410aceac","2429": "c5b074131e392dae","3093": "f9645b7a6dfd5411","386": "355745cf98e88f5d","5155": "25e43d52410aceac","7882": "bf2467ba9c49d988","8679": "9cdd851a0a044552","9758": "a8d311b114ec77ce",}[chunkId] + ".css"
}